import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { API } from 'api/ky';
import { MASTER_DATA_QUERIES } from 'hooks/query/masterData/masterData.queries';

type Variables = DefaultDownloadVariables<'masterOrderIds'>;

interface UseMutationGeneric {
  TData: Awaited<ReturnType<typeof fetchDownloadMasterOrder>>;
  TError: Error;
  TVariable: Variables;
  TMutationContext: ReturnType<typeof MASTER_DATA_QUERIES.DOWNLOAD_MASTER_ORDER>[0] & {
    variables: UseMutationGeneric['TVariable'];
  };
}

const fetchDownloadMasterOrder = async ({ endPoint, variables }: UseMutationGeneric['TMutationContext']) =>
  await API.post(endPoint, {
    json: variables,
  }).then(async response => ({
    data: await response.arrayBuffer(),
    title: decodeURIComponent(response.headers.get('Content-Disposition')?.split('filename=')[1] ?? ''),
  }));

const useDownloadMasterOrder = <TContext = UseMutationGeneric['TData']> (
  options?: UseMutationOptions<
    UseMutationGeneric['TData'],
    UseMutationGeneric['TError'],
    UseMutationGeneric['TVariable'],
    TContext
  >,
) =>
  useMutation<UseMutationGeneric['TData'], UseMutationGeneric['TError'], UseMutationGeneric['TVariable'], TContext>(
    MASTER_DATA_QUERIES.DOWNLOAD_MASTER_ORDER(),
    (variables: UseMutationGeneric['TVariable']) =>
      fetchDownloadMasterOrder({
        variables: variables,
        ...MASTER_DATA_QUERIES.DOWNLOAD_MASTER_ORDER()[0],
      }),
    options,
  );

export { fetchDownloadMasterOrder, useDownloadMasterOrder };
export type { Variables as DownloadMasterOrderVariables };
